import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@components/Dialog";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

interface RenderDialogLinkProps {
	onClose: () => void;
	onFollowLink: () => void;
}

export const MessageLinkDialog = ({ onClose, onFollowLink }: RenderDialogLinkProps) => (
	<>
		<Dialog open={true} onOpenChange={onClose}>
			<DialogContent className="max-w-87.5">
				<DialogHeader>
					<DialogTitle className="w-[90%]">
						You are leaving our platform. We are not responsible for external links. Proceed with care
					</DialogTitle>
				</DialogHeader>

				<DialogFooter>
					<Stack direction="row" spacing={8} wide>
						<Button onClick={onFollowLink} wide>
							<Typography weight="bold" type="p" padding="none" size="sm">
								Proceed
							</Typography>
						</Button>
						<Button onClick={onClose} type="secondary" wide>
							<Typography weight="bold" type="p" padding="none" size="sm">
								Cancel
							</Typography>
						</Button>
					</Stack>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	</>
);
